import React from 'react';
import { BiUserCircle, BiCreditCard, BiCalendarEvent } from 'react-icons/bi';
import { SidebarProps } from '../../Interfaces/Interfaces';
import { Link } from 'react-router-dom'


const Sidebar: React.FC<SidebarProps> = ({ setScreen }) => {

  const handleButtonPress = (screen: string) => {
    setScreen(screen);
  }

  return (
    <div className='w-72 h-screen bg-background_home flex flex-col items-center justify-start pt-20 gap-32 top-0 sticky'>
      <Link to='/'>
        <h1 className='text-white font-bold text-3xl'>Dra. M Weed</h1>
      </Link>

      <div className='w-auto flex flex-col gap-20'>
      <div className='flex flex-row gap-3'>
        <BiUserCircle size={22} style={{ color: 'white' }} />
        <button
          className='text-white hover:text-slate-300'
          onClick={() => handleButtonPress('Usuarios')}
        >
          Usuarios
        </button>
      </div>


      <div className='flex flex-row gap-3'>
        <BiCalendarEvent size={22} style={{ color: 'white' }} />
        <button
          className='text-white hover:text-slate-300'
          onClick={() => handleButtonPress('Turnos')}
        >
          Turnos
        </button>
      </div>


      <div className='flex flex-row gap-3'>
        <BiCreditCard size={22} style={{ color: 'white' }} />
        <button
          className='text-white hover:text-slate-300'
          onClick={() => handleButtonPress('Tarjetas')}
        >
          Tarjetas
        </button>
      </div>
      </div>


    </div>
  );
};

export default Sidebar;